import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Nota } from '../../../../types/Nota.type';
import { IntegradorService } from '../../../../services/integrador.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-nota',
  templateUrl: './nota.component.html',
  styleUrl: './nota.component.css',
  providers: [ConfirmationService]
})
export class NotaComponent implements OnInit {

  loading: boolean = false;
  notas: Nota[] = []

  constructor(private integradorService: IntegradorService, private router: Router,
              private toastService: ToastService, private confirmationService: ConfirmationService) {}

  ngOnInit(){
    this.carregarNotas();
  }

  carregarNotas(){
    this.loading = true;
    this.notas = [];
    this.integradorService.getNotas().subscribe({
      next: (data) => {
        this.notas = data
      },
      error: (error) => {
        this.loading = false;
        this.toastService.erro("Erro", error.error.message);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  abreNovoDialog() {
    this.router.navigate(["novo"])
  }

  excluir(id: string){
    this.integradorService.deleteNota(id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Nota excluída com sucesso");
        this.carregarNotas();
      },
      error: (value) => {
       this.toastService.erro("Erro", "Erro ao excluir: " + value)
      }
    })
  }

  confirmarExclusao(id: string) {
    this.confirmationService.confirm({
      message: 'Tem certeza de que deseja excluir ?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.excluir(id);
      }
      });
  }
}
